import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../../src/config";
import { Container, Card, Form, Button, Alert } from 'react-bootstrap';
import Cookies from 'js-cookie';
import 'bootstrap/dist/css/bootstrap.min.css';
import AdminGeralLayout from "../../components/AdminGeralLayout/AdminGeralLayout";

function ConfiguracoesAdminGeral() {
  const [formData, setFormData] = useState({
    nome: "",
    email: "",
    celular: "",
    appKey: "",
    authKey: "",
    novaSenha: ""
  });

  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState("");
  const [sucesso, setSucesso] = useState("");

  useEffect(() => {
    carregarConfiguracoes();
  }, []);

  const carregarConfiguracoes = async () => {
    try {
      const token = Cookies.get("authToken");
      const usuario = JSON.parse(Cookies.get("usuario"));
      
      const response = await axios.get(`${API_BASE_URL}/admin-geral/${usuario.id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const admin = response.data;
      setFormData({
        nome: admin.nome || "",
        email: admin.email || "",
        celular: admin.celular || "",
        appKey: admin.AppKey || "",
        authKey: admin.AuthKey || "",
        novaSenha: ""
      });

      setLoading(false);
    } catch (err) {
      console.error(err);
      setErro("Erro ao carregar configurações.");
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro("");
    setSucesso("");

    try {
      const token = Cookies.get("authToken");
      const usuario = JSON.parse(Cookies.get("usuario"));
      
      const payload = {
        nome: formData.nome,
        email: formData.email,
        celular: formData.celular,
        appKey: formData.appKey || null,
        authKey: formData.authKey || null,
        novaSenha: formData.novaSenha || null
      };

      await axios.put(`${API_BASE_URL}/admin-geral/${usuario.id}`, payload, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setSucesso("Configurações atualizadas com sucesso!");
      // Atualiza o cookie do usuário
      const updatedUser = { ...usuario, nome: formData.nome, email: formData.email, celular: formData.celular };
      Cookies.set("usuario", JSON.stringify(updatedUser), { expires: 7 });
      
      // Limpa o campo de senha
      setFormData(prev => ({ ...prev, novaSenha: "" }));

    } catch (err) {
      console.error(err);
      if (err.response && err.response.data && err.response.data.message) {
        setErro(err.response.data.message);
      } else {
        setErro("Erro ao atualizar configurações.");
      }
    }
  };

  return (
    <AdminGeralLayout activeKeyProp="configuracoes">
      <div className="mb-4">
        <h1>Configurações do Administrador Geral</h1>
        <p className="text-muted">Gerencie suas informações de acesso e credenciais do WhatsApp.</p>
      </div>

      {loading ? (
        <p>Carregando...</p>
      ) : (
        <Container fluid className="p-0">
          {erro && <Alert variant="danger" onClose={() => setErro("")} dismissible>{erro}</Alert>}
          {sucesso && <Alert variant="success">{sucesso}</Alert>}

        <Card className="shadow-sm" style={{width: "95%"}}>
            <Card.Body>
              <Form onSubmit={handleSubmit}>
                <h5 className="mb-3">Dados Pessoais</h5>
                <Form.Group className="mb-3">
                  <Form.Label>Nome *</Form.Label>
                  <Form.Control
                    type="text"
                    name="nome"
                    value={formData.nome}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Email *</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Celular *</Form.Label>
                  <Form.Control
                    type="text"
                    name="celular"
                    value={formData.celular}
                    onChange={handleChange}
                    placeholder="Ex: 11999999999"
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Nova Senha (deixe em branco para não alterar)</Form.Label>
                  <Form.Control
                    type="password"
                    name="novaSenha"
                    value={formData.novaSenha}
                    onChange={handleChange}
                  />
                </Form.Group>

                <hr />

                <h5 className="mb-3">Credenciais do WhatsApp (Administrador Geral)</h5>
                <Form.Group className="mb-3">
                  <Form.Label>App Key</Form.Label>
                  <Form.Control
                    type="text"
                    name="appKey"
                    value={formData.appKey}
                    onChange={handleChange}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Auth Key</Form.Label>
                  <Form.Control
                    type="text"
                    name="authKey"
                    value={formData.authKey}
                    onChange={handleChange}
                  />
                </Form.Group>

                <div className="d-flex justify-content-end">
                  <Button variant="primary" type="submit">
                    Salvar Configurações
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Container>
      )}
    </AdminGeralLayout>
  );
}

export default ConfiguracoesAdminGeral;
